export default __webpack_public_path__ + "static/media/antp_webinar_IniciativaPrivada_Ponentes.3af443a4.jpg";